<template>
  <div>
    <el-dialog
      v-dialogDrag
      title="整改延期记录"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="1200px"
      append-to-body
    >
      <div>
        <el-tabs v-model="activeName" @tab-click="handClick">
          <el-tab-pane
            :label="'延期记录' + (index + 1)"
            :name="index"
            v-for="(item, index) in delayRecordList"
            :key="index"
          ></el-tab-pane>
        </el-tabs>
        <div class="flex">
          <div class="flex-1 pr-100px pl-10px">
            <DelayCom :disabled="true" ref="delayFormCom" />
          </div>
          <div class="w-400px">
            <el-button @click="viewProcess" class="right-20px top-20px" plain style="z-index:999"
              >查看流程</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 查看流程start -->
    <ReportFlow
      :visible.sync="showFlowDialog"
      v-if="showFlowDialog"
      :flowid="flowid"
      :groupid="groupid"
    />
    <!-- 查看流程end -->
  </div>
</template>
<script>
import { PlanApi } from '@wiz-api/emergency-management'
import DelayCom from './DelayCom'

const ReportFlow = () => {
  return import('./ReportFlow')
}

const planApi = new PlanApi()
export default {
  name: 'violation-delay-records',
  components: { DelayCom, ReportFlow },
  props: {
    visible: {
      default: false,
      type: Boolean,
    },
    delayRecordList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  data() {
    return {
      activeName: 0,
      flowid: '',
      groupid: '',
      showFlowDialog: false,
    }
  },
  mounted() {
    this.handClick()
  },

  methods: {
    // 流程
    async viewProcess() {
      console.log(this.delayRecordList, this.delayRecordList[this.activeName], 'test')
      if (
        typeof this.delayRecordList[this.activeName].flowTaskId === 'string' &&
        _.includes(this.delayRecordList[this.activeName].flowTaskId, '-')
      ) {
        window.wiz.OpenWorkFlowDesignByFlowId(this.delayRecordList[this.activeName].flowTaskId)
        return
      }
      const [err, res] = await planApi.getFlowTaskInfo({
        flowTaskId: this.delayRecordList[this.activeName].flowTaskId,
      })
      if (!err) {
        this.flowid = res.flowId
        this.groupid = res.groupId
        this.showFlowDialog = true
      }
    },
    handClick() {
      this.$nextTick(() => {
        this.$refs.delayFormCom?.detailShow(this.delayRecordList[this.activeName])
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-step__line {
  background-color: #0f40f5;
}
</style>
